import React, { useEffect, useRef } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { extend } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Link } from '@one-thd/sui-atomic-components';
import { SalientPoints } from '../component/SalientPoints';
import { SalientListItem } from '../component/SalientListItem';
import { PIPSampleAnchorSku } from './PIPSampleAnchorSku';
import { getIconsByItemId } from '../component/salient-points-icons/IcontoSkuMapping';

export const PIPSalientPoints = ({ itemId, showSampleAnchorSku = false }) => {
  const salientIconsTest = useConfigService('fs-prop:salientIconsTest') || 'original';
  const salientIconsSet = useConfigService('fs-prop:salientIconsSet') || 'C';
  const setExpandedRef = useRef(null);
  const productDetailsRef = useRef(null);
  const iconBasedPoints = getIconsByItemId(itemId, salientIconsSet);
  const isIconLayout = iconBasedPoints.length > 0 && salientIconsTest !== 'original';
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('accordion.mount', ({ output }) => {
      const { wrapperIds, setExpanded } = output;
      setExpandedRef.current = setExpanded;
      productDetailsRef.current = document.querySelector('#' + wrapperIds[0]);
    }
    );
  }, []);

  const handleClick = (evt) => {
    if (setExpandedRef.current && productDetailsRef.current) {
      setExpandedRef.current(0)(evt, true);
      const element = productDetailsRef.current;
      const STICKY_HEADER_HEIGHT = 125;
      const top = element.getBoundingClientRect().top + window.pageYOffset - STICKY_HEADER_HEIGHT;
      if (isIconLayout) {
        sessionStorage.setItem('salient-points-view-more-details', salientIconsTest);
      }
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const ViewMoreDetails = () => (
    <Link
      className="sui-text-base sui-leading-normal sui-font-regular sui-underline"
      underline="always"
      href="#see-more-details"
      onClick={handleClick}
      data-testid="view-more"
    >
      View More Details
    </Link>
  );
  return (
    <>
      {showSampleAnchorSku && (
        <PIPSampleAnchorSku
          itemId={itemId}
          showSampleAnchorSku={showSampleAnchorSku}
        />
      )}
      <SalientPoints
        itemId={itemId}
        max={3}
        data-component="PIPSalientPoints"
        iconBasedPoints={iconBasedPoints}
        isIconLayout={isIconLayout}
        salientIconsTest={salientIconsTest}
      >
        {isIconLayout ? (
          <ViewMoreDetails />
        ) : (
          <SalientListItem>
            <ViewMoreDetails />
          </SalientListItem>
        )}
      </SalientPoints>
    </>
  );
};

PIPSalientPoints.displayName = 'PIPSalientPoints';
PIPSalientPoints.propTypes = {
  itemId: string.isRequired,
  showSampleAnchorSku: bool,
};
PIPSalientPoints.dataModel = extend({}, PIPSampleAnchorSku, SalientPoints);
